import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../auth/services/auth.service';

export const internalUserGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const email = authService.getUserInfo()?.email?.toLowerCase() ?? '';

  const isInternal = email.endsWith('@terramagna.com.br') || email.endsWith('@tmdigital.ag');

  if (!isInternal) {
    router.navigate(['/nao-autorizado'], { queryParams: { from: state.url, reason: 'not_internal_user' } });
    return false;
  }

  return true;
};
